<template>
  <div class="date-time-picker">
    <van-popup v-model="visible" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        :type="type"
        :min-date="min"
        :max-date="max"
        :formatter="formatter"
        @cancel="cancel"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import { Popup, DatetimePicker } from "vant";
// import { formatDate } from "@/utils/common";
// import cloneDeep from "lodash/cloneDeep";
import moment from "moment";

export default {
  name: "DateTimePicker",
  components: {
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,
  },
  props: {
    value: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "date",
    },
    minDate: {
      type: String,
      default: "",
    },
    maxDate: {
      type: String,
      default: "",
    },
    format: {
      type: String,
      default: "",
    },

    change: { type: Function },
  },
  data() {
    return {
      visible: false,
      currentDate: new Date(),
    };
  },
  created: function() {
    if (this.value) {
      this.currentDate = new Date(this.value);
    } else {
      this.currentDate = new Date();
    }
  },
  mounted() {
    this.visible = true;
  },
  computed: {
    min() {
      if (this.minDate) {
        return new Date(this.minDate);
      } else {
        return new Date(1900, 1, 1);
      }
    },
    max() {
      if (this.maxDate) {
        return new Date(this.maxDate);
      } else {
        var now = new Date();
        now.setFullYear(now.getFullYear() + 10);
        return now;
      }
    },
  },
  methods: {
    formatter(type, val) {
      if (type === "year") {
        return val + "年";
      }
      if (type === "month") {
        return val + "月";
      }
      if (type === "day") {
        return val + "日";
      }
      return val;
    },
    onConfirm(data) {
      let date = data;
      if (this.format) {
        date = moment(data).format(this.format);
      }
      this.$emit("change", date);
      this.cancel();
    },
    cancel() {
      this.visible = false;
      this.$emit("destroy");
    },
  },
};
</script>

<style lang="less"></style>
